import axios from 'axios';

const profileApi = () => `${process.env.REACT_APP_BACKEND_URL}/api/v1/profile`;

export const fetchProfile = async () => {
  const { data } = await axios.get(profileApi(), { withCredentials: true });
  return data;
};

export const buildProfilePayload = (form) => ({
  name: form.name?.trim() ?? '',
  phone: form.phone?.trim() || null,
  city: form.city?.trim() || null,
  state: form.state?.trim() || null,
  date_of_birth: form.date_of_birth?.trim() || null,
  bio: form.bio?.trim() || null,
  portfolio_url: form.portfolio_url?.trim() || null,
  linkedin_url: form.linkedin_url?.trim() || null,
  filmmaking_interest: form.filmmaking_interest?.trim() || null,
});

export const updateProfile = async (form) => {
  const payload = buildProfilePayload(form);
  const { data } = await axios.post(profileApi(), payload, { withCredentials: true });
  return data;
};

export const addEducation = async (payload) => {
  const { data } = await axios.post(`${profileApi()}/education`, payload, { withCredentials: true });
  return data;
};

export const deleteEducation = async (educationId) => {
  const { data } = await axios.delete(`${profileApi()}/education/${educationId}`, {
    withCredentials: true,
  });
  return data;
};
